import { trueFalseToYesNo } from '@/util/formatters'
let ifOccurredAbroad = (obj) => { return obj.occurredAbroad }

let tripDetailsInputs = [
    {
        id: 'occurredAbroad',
        label: 'Incident Occurred Abroad',
        type: 'text',
        placeholder: 'Incident Occurred Abroad',
        dataPath: 'occurredAbroad',
        customFormatter: trueFalseToYesNo
    },
    {
        id: 'tripStartDate',
        label: 'Trip Start Date',
        type: 'text',
        placeholder: 'Trip Start Date',
        dataPath: 'incidentDetails.tripStartDate',
        visible: ifOccurredAbroad
    },
    {
        id: 'tripEndDate',
        label: 'Trip End Date',
        type: 'text',
        placeholder: 'Trip End Date',
        dataPath: 'incidentDetails.tripEndDate',
        visible: ifOccurredAbroad
    },
    {
        id: 'tripCountry',
        label: 'Country',
        type: 'text',
        placeholder: 'Country',
        dataPath: 'incidentDetails.tripCountry',
        visible: ifOccurredAbroad
    }
]

export { tripDetailsInputs }